import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { AuthGuard } from './services/auth.guard';
//Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { LoginComponent } from './pages/login.component';
import { P404Component } from './pages/404.component';
import { ProfileComponent } from './profile/profile.component'

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'signin',
    component:LoginComponent
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: '首頁'
    },
    children: [
      {
        path: 'dashboard',
        canActivate:[AuthGuard],
        loadChildren: './dashboard/dashboard.module#DashboardModule',
        data: {
          title: '營運摘要'
        }
      },
      {
        path: 'brands',
        canActivate:[AuthGuard],
        data:{
          title:'品牌管理'
        },
        loadChildren: './brands/brands.module#BrandsModule'
      },
      {
        path: 'products',
        canActivate:[AuthGuard],
        data: {
          title: null
        },
        loadChildren: './products/products.module#ProductsModule'
      },
      {
        path: 'stores',
        canActivate:[AuthGuard],
        data: {
          title: '店家管理'
        },
        loadChildren: './stores/stores.module#StoresModule'
      },
      {
        path: 'staff',
        canActivate:[AuthGuard],
        data: {
          title: null
        },
        loadChildren: './staff/staff.module#StaffModule'
      },
      {
        path: 'reports',
        canActivate:[AuthGuard],
        data: {
          title: null
        },
        loadChildren: './reports/reports.module#ReportsModule'
      },      
      {
        path:'profile',
        canActivate:[AuthGuard],
        component:ProfileComponent,
        data: {
          title: '帳戶資訊'
        }
      }
    ]
  },
  {
    path:'**',
    component:P404Component
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {preloadingStrategy:PreloadAllModules}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts